import { Button, Form, Input } from 'antd';
import React, { useCallback, useEffect } from 'react';
import { ArrowRightUpIcon } from "@solar-icons/react/outline/arrow-right-up";
import { UserRoundedIcon } from "@solar-icons/react/outline/user-rounded";
import { LockKeyholeMinimalisticIcon } from "@solar-icons/react/outline/lock-keyhole-minimalistic";
import { InboxLineIcon } from "@solar-icons/react/outline/inbox-line";
import { Login2Icon } from "@solar-icons/react/outline/login-2";
import { RouteIcon } from "@solar-icons/react/outline/route";
import { ShieldCheckIcon } from "@solar-icons/react/outline/shield-check";
import { ArrowLeftIcon } from "@solar-icons/react/outline/arrow-left";
import { EyeIcon } from "@solar-icons/react/outline/eye";
import { EyeClosedIcon } from "@solar-icons/react/outline/eye-closed";
import { useDispatch, useSelector } from 'react-redux';
import { login } from '../../redux/reducer/auth';
import { loadVersionLast } from '../../redux';
import { AppVersion } from '../../config/appVersion';
import { BaseColor } from '../../config/env';
import './login.less';

const hue = (hex) => {
    const value = hex.replace('#', '');
    const rgb = [0, 2, 4].map(index => parseInt(value.slice(index, index + 2), 16) / 255);
    const max = Math.max(...rgb), min = Math.min(...rgb);
    if (max === min) return 0;
    const delta = max - min;
    const result = max === rgb[0]
        ? ((rgb[1] - rgb[2]) / delta + (rgb[1] < rgb[2] ? 6 : 0))
        : max === rgb[1] ? (rgb[2] - rgb[0]) / delta + 2 : (rgb[0] - rgb[1]) / delta + 4;
    return result * 60;
};

const visualStyle = { '--login-brand': BaseColor, '--login-hue': `${Math.round(hue(BaseColor) - hue('#158550'))}deg` };

const Logo = () => (
    <div className="login-logo">
        <img src="/images/iacas.png" alt="IACAS" />
        <div><strong>IACAS</strong><span>Integrated Airline &amp; Customs Automation System</span></div>
    </div>
);

const Stat = ({ icon: Icon, label, value }) => (
    <div className="login-stat"><div><Icon size={16} /><span>{label}</span></div><strong>{value}</strong></div>
);

const VisualPanel = () => (
    <section className="login-visual" style={visualStyle}>
        <img className="login-route" src="/images/login-route-lines.svg" alt="" />
        <img className="login-orbit" src="/images/login-ellipse-large.png" alt="" />
        <img className="login-orbit-inner" src="/images/login-ellipse.svg" alt="" />
        <img className="login-dots" src="/images/dot-grid.svg" alt="" />
        <div className="login-copy">
            <small>Integrated Airline &amp; Customs Automation System</small>
            <h2>Satu gerbang untuk seluruh<br />alur kargo udara Anda.</h2>
        </div>
        <div className="login-art">
            <img className="login-cargo" src="/images/cargo-hub.svg" alt="" />
            <img className="login-awb" src="/images/art-awb-tag.svg" alt="" />
            <img className="login-stamp" src="/images/art-customs-stamp.svg" alt="" />
            <img className="login-spark spark-one" src="/images/art-sparkle.svg" alt="" />
            <img className="login-spark spark-two" src="/images/art-sparkle.svg" alt="" />
        </div>
        <div className="login-monitoring">
            <div className="monitoring-title"><ShieldCheckIcon size={18} /> <span>Display Monitoring · status pengiriman hari ini</span></div>
            <div className="login-stats">
                <Stat icon={ArrowRightUpIcon} label="Export" value="412" />
                <Stat icon={InboxLineIcon} label="Import" value="538" />
                <Stat icon={RouteIcon} label="Distribusi" value="334" />
            </div>
        </div>
    </section>
);

export default ({ apps }) => {
    const dispatch = useDispatch();
    const { versionLastCache: beVersion } = useSelector(state => state.apps);

    const onFinished = useCallback(values => dispatch(login({ ...values, app: apps })), [dispatch, apps]);
    useEffect(() => { dispatch(loadVersionLast()); }, [dispatch]);

    return (
        <main className="login-page">
            <section className="login-form-column">
                <Logo />
                <div className="login-form-wrap">
                    <Form className="login-form" layout="vertical" onFinish={onFinished} requiredMark={false}>
                        <div className="login-heading">
                            <div className="login-chip"><ShieldCheckIcon size={16} /> IACAS</div>
                            <h1>Login</h1>
                            <p>Masuk untuk melanjutkan akses aplikasi IACAS.</p>
                        </div>
                        <Form.Item name="user" label="Username" rules={[{ required: true, message: 'Username Required' }]}>
                            <Input autoFocus size="large" placeholder="Masukkan username" prefix={<UserRoundedIcon size={20} />} autoComplete="username" />
                        </Form.Item>
                        <Form.Item name="password" label="Password" rules={[{ required: true, message: 'Password Required' }]}>
                            <Input.Password size="large" placeholder="Masukkan password" prefix={<LockKeyholeMinimalisticIcon size={20} />} autoComplete="current-password" iconRender={(visible) => (visible ? <EyeIcon size={20} /> : <EyeClosedIcon size={20} />)} />
                        </Form.Item>
                        <Button htmlType="submit" type="primary" block size="large" icon={<Login2Icon size={20} />}>Login</Button>
                    </Form>
                </div>
                <div className="login-footnote">
                    <a className="login-back" href="/" aria-label="Kembali ke beranda"><ArrowLeftIcon size={20} /></a>
                    <div>COPYRIGHT © 2026 <b>Edifly Solusi Indonesia</b></div>
                    <code>Fe: v{AppVersion} &nbsp;|&nbsp; Be: v{beVersion?.version}</code>
                </div>
            </section>
            <VisualPanel />
        </main>
    );
};
